<template>
  <span class="customer-header">
    <span v-if="showName" class="customer-name">{{ customer.first_name }} {{ customer.last_name }}</span>
    <span class="customer-email ml-2">{{ customer.email }}</span>
    <v-btn icon small class="ml-1" :title="`Copy ${customer.email}`" @click="copyEmail">
      <v-icon small>mdi-email-outline</v-icon>
    </v-btn>
    <router-link v-if="showLink" :to="{name: 'Customer', params: {id: customer.uid}}">
      <v-btn icon small title="Customer profile">
        <v-icon small>mdi-account</v-icon>
      </v-btn>
    </router-link>
    <v-btn
      icon
      small
      title="Search in Missive"
      :href="missiveSearchUrl"
      target="_blank"
    >
      <v-icon small>mdi-email-search</v-icon>
    </v-btn>
    <v-snackbar v-model="copied" timeout="1500" top right>
      Copied {{ customer.email }}
    </v-snackbar>
  </span>
</template>

<script>
export default {
  name: 'CustomerHeader',
  props: {
    customer: {
      type: Object,
      required: true,
    },
    showLink: {
      type: Boolean,
      default: true,
    },
    showName: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      copied: false,
    };
  },
  computed: {
    missiveSearchUrl() {
      return `https://mail.missiveapp.com/#search/${encodeURIComponent(`${this.customer.email}`)}`;
    },
  },
  methods: {
    async copyEmail() {
      try {
        await navigator.clipboard.writeText(this.customer.email);
      } catch (e) {
        const el = document.createElement('textarea');
        el.value = this.customer.email;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
      this.copied = true;
    },
  },
};
</script>

<style scoped>
.customer-header {
  display: inline-flex;
  align-items: center;
}
.customer-name {
  font-weight: 500;
}
.customer-email {
  opacity: 0.7;
  font-size: 0.85em;
}
</style>
